export default "__VITE_ASSET__D44a9vi8__"